export const config = {
  pagination: {
    clickable: true,
  },
  spaceBetween: 0,
  slidesPerView: 1,
}
